<button
  odxButton
  variant="secondary"
  (click)="toggleItemTextVisibility()"
  [odxTooltip]="itemTextVisible ? tooltipTextHideCategory : tooltipTextShowCategory"
  [odxTooltipOptions]="{ position: 'bottom' }"
>
  <odx-icon [name]="itemTextVisible ? 'closed-caption' : 'closed-caption-off'" size="medium"></odx-icon>
</button>
